import React, { useEffect, useRef } from 'react';
import Swiper from 'swiper';
import { EffectFade, Pagination, Autoplay } from 'swiper/modules'; // Import Autoplay
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

const Slider = () => {

    const swiperRef = useRef(null);

    useEffect(() => {
        if (swiperRef.current) {
            const swiper = new Swiper(swiperRef.current, {
                modules: [EffectFade, Pagination, Autoplay], // Include Autoplay module
                effect: 'fade',
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                speed: 2000, // Transition speed between slides (in milliseconds)
            });

            return () => swiper.destroy();
        }
    }, []);

    return (
        <>
            <div className="th-hero-wrapper hero-1" id="hero">
                <div
                    className="swiper th-slider hero-slider-1"
                    id="heroSlide1"
                    ref={swiperRef}
                // data-slider-options='{"effect":"fade","menu": ["", "", ""],"heroSlide1": {"swiper-container": {"pagination": {"el": ".swiper-pagination", "clickable": true }}}}'
                >
                    <div className="swiper-wrapper">
                        <div className="swiper-slide">
                            <div className="hero-inner">
                                <div className="th-hero-bg">
                                    <img src="/assets_web/img/homeSlider/Slider_01.png" alt="Slide_1" />
                                    {/* <div className="overlay"></div> */}
                                </div>
                                {/* <div className="container">
                                    <div className="hero-style1">
                                        <div
                                            className="btn-group"
                                            data-ani="slideinup"
                                            data-ani-delay="0.6s"
                                        >
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="hero-inner">
                                <div className="th-hero-bg">
                                    <img src="/assets_web/img/homeSlider/Slider_02.png" alt="Slide_2" />
                                    {/* <div className="overlay"></div> */}
                                </div>
                                {/* <div className="container">
                                    <div className="hero-style1">
                                        <div
                                            className="btn-group"
                                            data-ani="slideinup"
                                            data-ani-delay="0.6s"
                                        >
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="hero-inner">
                                <div className="th-hero-bg">
                                    <img src="/assets_web/img/homeSlider/Slider_03.png" alt="Slide_3" />
                                    {/* <div className="overlay"></div> */}
                                </div>
                                {/* <div className="container">
                                    <div className="hero-style1">
                                        <div
                                            className="btn-group"
                                            data-ani="slideinup"
                                            data-ani-delay="0.6s"
                                        >
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </>

    )
}

export default Slider
